import "jquery-ui/themes/base/all";
import "themes/general/desktop";
import "themes/flygcity/desktop";

import "components/desktop/cookie";

import "../../dep/google_analytics/desktop_triggers";
import "../../dep/skyscanner/desktop_triggers";

// Rebuild (redesign/rebuild-*): Tailwind + Turbo + Stimulus, loaded last so
// the unlayered reset block in tailwind.css wins source-order ties against
// the legacy theme imports above -- see that file for why.
import "../../styles/tokens/flygcity.css";
import "../../styles/tailwind.css";
import "@hotwired/turbo-rails";
import "../../controllers";
